module.exports = __webpack_public_path__ + "static/media/oneImg.d9baa207.png";